<template>
  <el-container class="app-container">
    <Navbar />
    <el-main>
      <router-view />
    </el-main>
    <el-footer class="footer">
      <p>© 2025 ImageX. All rights reserved.</p>
    </el-footer>
  </el-container>
</template>
<script>
import Navbar from './views/navbar.vue';

export default {
  name: 'App',
  components: {
    Navbar,
  }
}
</script>

<style>
body {
  font-family: var(--font-body);
  margin: 0;
  padding: 0;
  min-height: 98vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-page);
}

.app-container {
  min-height: 98vh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.el-main {
  flex: 1;
  padding: var(--spacing-lg);
  background: var(--bg-page);
}

.footer {
  background-color: var(--bg-card);
  color: var(--text-tertiary);
  text-align: center;
  padding: var(--spacing-lg) 0;
  font-size: var(--text-sm);
  border-top: 1px solid var(--border-light);
  width: 100%;
  font-family: var(--font-heading);
  letter-spacing: 0.05em;
}

.main-content {
  display: flex;
  padding: var(--spacing-lg);
  gap: var(--spacing-md);
}

.editor,
.output {
  flex: 1;
}
</style>
